'use strict';

import Cookies from 'js-cookie';
import acceptedCookiePolicy from '../../components/onetrust/cookiePolicy';
import {waitForDependencies, getCurrentEnv} from "../_imports/utils/utils.common";
import { debouncer } from '../../utils/utils'

const pushBannerMaxViewCount = 10;
const pushBannerDismissValue = 'dismiss';

const setPushBannerHeightVariable = (pushBanner) => {
    const pushBannerHeight = pushBanner?.getBoundingClientRect().height ?? 0;

    document.documentElement.style.setProperty("--push-banner-height", `${pushBannerHeight}px` )
}

const closePushBanner = (pushBannerElement) => {
    const pushBannerHeight = pushBannerElement.getBoundingClientRect().height;

    pushBannerElement.style.marginTop = `-${pushBannerHeight}px`;
    document.documentElement.classList.remove('push-banner-is-visible');

    setTimeout(() => {
        pushBannerElement.remove();
        document.documentElement.classList.remove('push-banner');
    }, 700);

    const pushBannerCookie = getCookieName(pushBannerElement);

    if (pushBannerCookie) {
        setCookieValue(pushBannerElement, () => 'dismiss');
    }
};

const getCookieName = pushBannerElement => {
    const pushBannerId = pushBannerElement.dataset.pushBannerId;

    return `pushBanner_${pushBannerId}`;
};

const setCookieValue = (pushBannerElement, cookieValue) => {
    const pushBannerCookieName = getCookieName(pushBannerElement);

    acceptedCookiePolicy({
        ifFunctionalCookies: () => {
            const pushBannerCookieValue = Cookies.get(pushBannerCookieName);

            Cookies.set(pushBannerCookieName, cookieValue(pushBannerCookieValue));
        }
    });
};

const initPushBanner = () => {
    const initPushBannerScript = () => {
        const pushBanner = document.querySelector('[am-push-banner]') || document.querySelector('.gtm-push-banner');

        if (pushBanner) {
            const pushBannerCookieName = getCookieName(pushBanner);

            setPushBannerHeightVariable(pushBanner);

            window.addEventListener('resize', debouncer(() => {
                setPushBannerHeightVariable(pushBanner);
            }, 150));
            
            if (pushBannerCookieName) {
                setCookieValue(pushBanner, cookieValue => {
                    let newCookieValue = 1;

                    if (cookieValue) {
                        if (cookieValue !== pushBannerDismissValue) {
                            let viewCount = parseInt(cookieValue) + 1 || newCookieValue;
                            newCookieValue = viewCount;

                            if (newCookieValue >= pushBannerMaxViewCount) {
                                newCookieValue = pushBannerDismissValue;
                            }
                        } else {
                            newCookieValue = pushBannerDismissValue;
                        }
                    }

                    return newCookieValue;
                });
            }

            const pushBannerCloseButton = pushBanner.querySelector('.push-banner-close');

            if (pushBannerCloseButton) {
                pushBannerCloseButton.addEventListener('click', () => closePushBanner(pushBanner));
            }
        }
    };

    initPushBannerScript();

    window.InitPushBannerScript = initPushBannerScript;
};

if(document.getElementById('push-banner-external-load')) {
    initPushBanner();
} else {
    waitForDependencies(() => {
        initPushBanner();
    });
}